import "./WorkCardStyles.css";
import React from "react";
import { NavLink } from "react-router-dom";

const WorkCard = (props) => {
  return (
    <div className="work-container">
      <div className="project-card">
        <img src={props.imgsrc} alt="img" />
        <h2 className="project-title">{props.title}</h2>
        <div className="pro-details">
          <p>{props.text}</p>
          <div className="pro-btns">
            <NavLink to={props.github} className="btn" target="_blank">
              GitHub
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkCard;
